import { BASE_SUBSCRIPTION_PATH } from '@finn/ua-constants';
import { BasePageData } from '@finn/ui-cosmic';
import { Locale } from '@finn/ui-utils/ssr';

import {
  FilterKey,
  FilterValuesObject,
  processFilters,
  VehicleViewKey,
} from '../helpers/filters';
import { getPageSize } from '../helpers/page-size';
import { deserializeFiltersFromPath } from '../helpers/parser';
import { getIsOutOfStock } from '../helpers/stock';
import { FiltersType, ProductGroupBy } from '../hooks/useProductListItems';
import { DiscoveryConfigContextType } from './MetadataProvider';
import { fetchProducts } from './ssr-raw-fetchers';

export const fetchAdjustedProductListItems = async (
  { apiConfig }: { apiConfig: DiscoveryConfigContextType['apiConfig'] },
  {
    filterValues,
    locale,
    pageData,
  }: {
    filterValues: FilterValuesObject;
    locale: string;
    pageData?: BasePageData;
  }
) =>
  fetchProducts(
    { apiConfig },
    {
      filters: {
        ...filterValues,
        [FilterKey.VIEW]: VehicleViewKey.DISPLAYED_CARS,
      },
      limit: getPageSize(true, pageData?.metadata?.campaign_cards?.length),
      locale,
    }
  );

export const fetchProductItems = async (
  { apiConfig }: { apiConfig: DiscoveryConfigContextType['apiConfig'] },
  {
    locale,
    slugArray,
    availableFilters,
    displayedFilters,
    pageData,
    groupBy,
  }: {
    locale?: string;
    slugArray?: string[];
    availableFilters?: FiltersType;
    displayedFilters: FiltersType;
    pageData?: BasePageData;
    groupBy?: ProductGroupBy;
  }
) => {
  const filterLocale = locale === Locale.ENGLISH_USA ? 'en-US' : 'de-DE';
  const filtersResponse = processFilters(
    availableFilters?.[filterLocale],
    displayedFilters?.[filterLocale]
  );

  const filterValues = slugArray
    ? deserializeFiltersFromPath(
        [...slugArray].join('/'),
        BASE_SUBSCRIPTION_PATH,
        locale ?? '',
        filtersResponse
      )
    : {};

  const isOutOfStock = getIsOutOfStock(filterValues, filtersResponse);
  //IS OUT OF STOCK RETURNS FALSE WHILE IT SHOULD BE TRUE

  const productListItemsResponse = await fetchProducts(
    { apiConfig },
    {
      filters: {
        ...filterValues,
        [FilterKey.VIEW]: isOutOfStock
          ? VehicleViewKey.DISPLAYED_CARS
          : VehicleViewKey.AVAILABLE,
      },
      limit: getPageSize(
        isOutOfStock,
        pageData?.metadata?.campaign_cards?.length
      ),
      locale: locale ?? '',
      groupBy,
    }
  );

  return {
    filterValues,
    productListItemsResponse,
    isOutOfStock,
    filtersResponse,
  };
};
